import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38c9b5ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9b5ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c9b5ca')) {
      api.createRecord('38c9b5ca', component.options)
    } else {
      api.reload('38c9b5ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38c9b5ca&scoped=true", function () {
      api.rerender('38c9b5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/liveClassSet/index.vue"
export default component.exports